// Off-site destinations linked from more than one place. Keep each URL here once.

export const HELP_CENTER_URL = "https://help.bouncie.com/en/"; // es/fr help centers have no articles
export const STATUS_URL = "https://status.bouncie.com/";
export const DEVELOPER_DOCS_URL = "https://docs.bouncie.dev/#/";

export const WEB_APP_URL = "https://www.bouncie.app/";
export const WEB_APP_ACTIVATE_URL = "https://www.bouncie.app/activate"; // account + device setup
export const WEB_APP_SUBSCRIPTIONS_URL = "https://www.bouncie.app/subscriptions";

export const APP_STORE_URL = "https://apps.apple.com/us/app/bouncie/id1211282909";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.taillight.bouncie";
export const AMAZON_STORE_URL = "https://www.amazon.com/bouncie";
